// ComplianceContent.jsx
import React from "react";
import { motion } from "framer-motion";
import "../styles/RegulatoryCompliance.css";
import { CheckCircle } from "lucide-react";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

const services = [
  {
    title: "Brand Strategy & Visual Identity",
    description:
      "We develop compelling brand strategies and visual identities that resonate with your audience and differentiate you in competitive markets.",
  },
  {
    title: "Social Media & Content Marketing",
    description:
      "From content calendars to creative execution, we craft engaging digital narratives that build loyal communities and boost brand awareness.",
  },
  {
    title: " Digital Growth Campaigns",
    description:
      "We design and execute targeted digital campaigns that drive traffic, leads, and conversions — maximizing ROI across platforms like Meta, Google, LinkedIn, and more.",
  },
  {
    title: "Website Planning & UX Strategy ",
    description:
      "We guide the creation of websites that don’t just look good — they work. Our focus is on intuitive design, mobile responsiveness, and user journeys that convert.",
  },
  {
    title: " Customer Experience (CX) Mapping ",
    description:
      "We analyze and optimize the end-to-end customer journey, helping you deliver memorable, consistent experiences that drive satisfaction and loyalty.",
  },
];

const ComplianceContent = () => {
  return (
    <motion.div
      className="compliance-content"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="elevate-image">
        <div className="elevate-overlay">
          <h2 className="overlay-head">Nexa Elevate</h2>
          <h3 className="italic-text">
            <em>Marketing. Branding. Digital Excellence.</em>
          </h3>
        </div>
      </div>
      <div className="compliance-text">
        <p>
          We elevate brands with purpose-driven storytelling, digital campaigns,
          and compelling customer engagement strategies that stand out in
          Africa’s crowded markets.
        </p>
      </div>
      <motion.div
        className="services-list"
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="service-card"
            variants={itemVariants}
          >
            <div className="icon-text">
              <div className="icon-wrap">
                <CheckCircle size={24} className="content-check-icon" />
              </div>
              <div className="service-text-content">
                <h4>{service.title}</h4>
                <p>{service.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default ComplianceContent;
